import { PropsWithChildren } from "react";

import { css, keyframes } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";

const scaleUpSm = keyframes({
    from: {
        /* Equivalent to Layout "10" */
        transform: "scale(0.8275)"
    }
});
const scaleUpMd = keyframes({
    from: {
        /* Equivalent to Layout "8" */
        transform: "scale(0.655)"
    },
    to: {
        /* Equivalent to Layout "10" */
        transform: "scale(0.8275)"
    }
});
const containerStyles = css({
    "transformOrigin": "50% 25%",
    [media.above.md]: {
        transform: "scale(0.8275)"
    },
    "@media (prefers-reduced-motion: no-preference)": {
        [media.above.sm]: {
            animationRange: "exit-crossing 20px exit-crossing 200px",
            animationTimeline: "scroll(block root)",
            animationTimingFunction: wacToken("motion.easing.ease-both"),
            animationFillMode: "backwards"
        },
        [media.only.sm]: {
            animationName: scaleUpSm
        },
        [media.above.md]: {
            animationName: scaleUpMd
        }
    }
});

export const ScrollToEnlarge = ({ children }: PropsWithChildren) => {
    return <div css={containerStyles}>{children}</div>;
};
